// @flow
import { CRUISE_PROGRAM } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_CRUISE_PROGRAM } from 'Utils/request/requestDictionary';
import { type ProgramProps } from 'Components/widgets/product-program/ProductProgram.jsx';

type CMSProps = {
  isDetailed: boolean,
  titlePlaceholder: string,
  subtitlePlaceholder: string,
  dateFormat: string,
  dayPlaceholder: string,
  departureTimePlaceholder: string,
  arrivalTimePlaceholder: string,
  id?: string,
};

type GQLProps = {
  cruise: {
    stopover: ProgramProps,
  },
};

export type LineProps = CMSProps & GQLProps;

export const cruiseProgramResolver = {
  name: CRUISE_PROGRAM,
  resolve: (
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: RouterLocation<CruiseUrlParams>,
  ): Promise<GQLProps> => {
    const {
      titlePlaceholder,
      subtitlePlaceholder,
      dateFormat,
      dayPlaceholder,
      departureTimePlaceholder,
      arrivalTimePlaceholder,
    } = props;

    const { urlParams } = location;
    const cruiseArgs = `cruiseDepartureDate: "${urlParams.departureDate}" cruiseArrivalDate: "${
      urlParams.arrivalDate
    }"`;

    const query = `{
      cruise(${cruiseArgs}) {
        stopover {
          title(message : "${titlePlaceholder}")
          subtitle(message : "${subtitlePlaceholder}" dateFormat : "${dateFormat}")
          stops {
            day(message : "${dayPlaceholder}")
            title
            description
            departureTime(message : "${departureTimePlaceholder}")
            arrivalTime(message : "${arrivalTimePlaceholder}")
          }
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_CRUISE_PROGRAM,
      strictErrors: false,
    });
  },
};
